import { Box, Card, CardHeader, Divider, Stack, ToggleButtonGroup, Typography } from "@mui/material";
import { useSettings } from "../../../hooks";
import { HubRounded, TableRowsOutlined } from "@mui/icons-material";
import { TeamNetworkGraph, TeamNetworkList } from "../../TeamPages/TeamOverviewPage/components";
import { TooltipToggleButton } from "../../../components";

interface IProps {
  teamSlug: string;
}

const TeamStructureReview = (props: IProps) => {
  const { teamSettings, updateTeamSettings } = useSettings();

  return (
    <Card sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <CardHeader
        title={
          <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Typography variant="h6">Network</Typography>
            <ToggleButtonGroup
              value={teamSettings.networkListView}
              color="primary"
              size="small"
              exclusive
              onChange={(_e, value: boolean) => updateTeamSettings({ ...teamSettings, networkListView: value })}
            >
              <TooltipToggleButton title="Graph View" value={false}>
                <HubRounded fontSize="small" />
              </TooltipToggleButton>

              <TooltipToggleButton title="List View" value={true}>
                <TableRowsOutlined fontSize="small" />
              </TooltipToggleButton>
            </ToggleButtonGroup>
          </Stack>
        }
      />
      <Divider />
      {!teamSettings.networkListView && (
        <Box
          sx={{
            height: { xs: "100vw", md: 500 },
            width: "100%",
          }}
        >
          <TeamNetworkGraph teamSlug={props.teamSlug} />
        </Box>
      )}

      {teamSettings.networkListView && <TeamNetworkList teamSlug={props.teamSlug} />}
    </Card>
  );
};

export { TeamStructureReview };
